import type { FC, ReactNode } from 'react';
import React from 'react';

interface SVModalProps {
  id?: string;
  children?: ReactNode;
  classNames?: string;
}

interface SVModalSubComponentProps {
  children?: ReactNode;
  classNames?: string;
  closeButton?: boolean;
  onClose?: () => void;
}

const SVModal: FC<SVModalProps> & {
  Header: FC<SVModalSubComponentProps>;
  Body: FC<SVModalSubComponentProps>;
  Footer: FC<SVModalSubComponentProps>;
} = ({ id = 'sv-modal', children = null, classNames = '' }) => {
  return (
    <div
      className="modal fade"
      id={id}
      tab-index="-1"
      aria-labelledby={`${id}Label`}
      aria-hidden="true"
    >
      <div className={`modal-dialog ${classNames}`}>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

// SVModal.Header Component
const Header: FC<SVModalSubComponentProps> = ({
  children = null,
  classNames = '',
  closeButton = true,
  onClose = () => {},
}) => (
  <div className={`modal-header ${classNames}`}>
    {children}
    {closeButton && (
      <button
        className="btn sv-close-btn btn-close"
        type="button"
        data-bs-dismiss="modal"
        onClick={onClose}
      >
        <img src="/images/sv-modal-cross-icon.svg" alt="Cross icon" />
      </button>
    )}
  </div>
);
Header.displayName = 'SVModal.Header';

// SVModal.Body Component
const Body: FC<SVModalSubComponentProps> = ({
  children = null,
  classNames = '',
}) => <div className={`modal-body ${classNames}`}>{children}</div>;
Body.displayName = 'SVModal.Body';

// SVModal.Footer Component
const Footer: FC<SVModalSubComponentProps> = ({
  children = null,
  classNames = '',
}) => <div className={`modal-footer ${classNames}`}>{children}</div>;
Footer.displayName = 'SVModal.Footer';

SVModal.Header = Header;
SVModal.Body = Body;
SVModal.Footer = Footer;

export default SVModal;
